import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const GettingStarted = () => {
  const faqs = [
    {
      question: "Q: What is JUNE ?",
      answer:
        "A: JUNE is a Trexo product designed for paralegals to streamline IP-related workflows. It offers features such as bibliographic data extraction for patents & trademarks (US and AU jurisdictions), form generation, reference downloading and extraction and office action draft preparation.",
    },
    {
      question: "Q: How do I get started ?",
      answer:
        "A: Once your subscription is active, we will need your user details (emails and roles) to set up accounts.",
    },
    {
      question: "Q: Does JUNE support Single Sign-On (SSO) ?",
      answer:
        "A: Yes, JUNE supports SSO for secure access within your organization.",
    },
    {
      question: "Q: What tasks can I perform using JUNE ?",
      answer:
        "A: JUNE simplifies IP workflows with the following capabilities:\n\n- Bibliographic Data Extraction\n- Form Generation (37 CFR forms, GPOA/POA, Change of Correspondence, Application & Patent forms)\n- IDS Workflows: 1449 & 892 Downloader, Reference Count, Reference Downloader, Reference Extractor, Embedded Fonts Removal, SB-08 Generator\n- AppGen\n- Oath/Dec & ADS Downloader\n- Office Action (OA) Shell Draft Preparation",
    },
    {
      question: "Q: How do I start a task in JUNE ?",
      answer:
        "A: Either select an intent from the left menu or type its name with the required input. JUNE will process it and return the results.",
    },
    {
      question: "Q: Can JUNE handle multiple simultaneous requests ?",
      answer:
        "A: Yes, JUNE is built to process multiple requests concurrently, ensuring minimal delays and maintaining high performance, even during peak usage.",
    },
    {
      question: "Q: Can I view or download my task history ?",
      answer:
        "A: Yes. The Track Task Screen allows you to view your task history for up to 7 days. From there you can also download your past outputs.",
    },
    {
      question: "Q: How often does JUNE update its features ?",
      answer:
        "A: JUNE provides regular updates, and all subscribers receive release notes by email when new features or improvements are rolled out."
    },
    {
      question: "Q: Why are some features disabled in my account ?",
      answer:
        "A: Disabled features may be due to either role-based restrictions set by your administrator or limitations of your subscription plan. Please contact your admin. If it’s plan-related, they can request activation from our support team.",
    },
    {
      question: "Q: Can I customize JUNE to fit my workflow ?",
      answer:
        "A: JUNE includes prebuilt features for fast deployment. Limited workflow customizations can be made upon request.",
    },
    {
      question: "Q: What data is available in JUNE for US applications ?",
      answer:
        "A: JUNE retrieves bibliographic data for US applications filed from 2000 onward. Records filed before 2000 cannot be retrieved through the platform.",
    },
    {
      question: "Q: What happens if my request takes more than 30 seconds to process ?",
      answer:
        "A: If a request takes longer than 30 seconds, JUNE will display a notification so you can track its progress under the “Track Task” section. Once the task is complete, you will also receive an email notification with a downloadable link to access the results.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default GettingStarted;
